import { useEffect } from "react";

const upsert = (sel, make) => { let el = document.head.querySelector(sel); if (!el) { el = make(); document.head.appendChild(el); } return el; };
const meta = (attr, key, content) => { if (content == null) return; const el = upsert(`meta[${attr}="${key}"]`, () => { const m = document.createElement("meta"); m.setAttribute(attr, key); return m; }); el.setAttribute("content", content); };

export function useSeo({ title, description, keywords, canonical, image, jsonLd = [], gsc }) {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    document.title = title;
    meta("name", "description", description);
    meta("name", "keywords", keywords);
    meta("property", "og:title", title);
    meta("property", "og:description", description);
    meta("property", "og:type", "website");
    meta("property", "og:url", canonical);
    meta("property", "og:image", image);
    meta("name", "twitter:card", "summary_large_image");
    meta("name", "twitter:title", title);
    meta("name", "twitter:description", description);
    if (gsc) meta("name", "google-site-verification", gsc);
    const link = upsert('link[rel="canonical"]', () => { const l = document.createElement("link"); l.rel = "canonical"; return l; });
    if (canonical) link.href = canonical;
    const scripts = jsonLd.map((obj) => { const s = document.createElement("script"); s.type = "application/ld+json"; s.dataset.seo = "1"; s.text = JSON.stringify(obj); document.head.appendChild(s); return s; });
    return () => { document.title = prevTitle; scripts.forEach((s) => s.remove()); };
  }, [title, description, keywords, canonical, image, gsc]); // eslint-disable-line react-hooks/exhaustive-deps
}
